import { useEffect, useRef } from "react";
import { HOST_API_KEY } from "../config-global";

export interface DeviceReading {
  id: number;
  deviceType: "TONOREF" | "PHOROPTER" | "LENSMETER";
  patientId?: string;
  data: Record<string, any>;
  status: "pending" | "accepted";
  receivedAt: string;
}

/**
 * Connects to GET /device-ingest/events and calls `onReading` for every
 * new device measurement that arrives. Reconnects automatically on error.
 */
export function useDeviceEvents(onReading: (r: DeviceReading) => void) {
  const cbRef = useRef(onReading);
  cbRef.current = onReading;

  useEffect(() => {
    if (!HOST_API_KEY) return;
    let es: EventSource;
    let retry: ReturnType<typeof setTimeout>;
    let delay = 2000;

    const connect = () => {
      es = new EventSource(`${HOST_API_KEY}device-ingest/events`);
      es.onmessage = (e) => {
        try {
          cbRef.current(JSON.parse(e.data));
        } catch {}
        delay = 2000;
      };
      es.onerror = () => {
        es.close();
        retry = setTimeout(() => {
          delay = Math.min(delay * 2, 30000);
          connect();
        }, delay);
      };
    };

    connect();
    return () => {
      es?.close();
      clearTimeout(retry);
    };
  }, []);
}
